const getAccountId = (url) => {
	const urlArray = url.split('/');
	const account = urlArray[urlArray.indexOf('accounts') + 1];
	return account;
};

const getMediaId = (url) => {
	const urlArray = url.split('/');
	const account = urlArray[urlArray.indexOf('medias') + 1];
	return account;
};

const NOTIFICATION_MESSAGES = {
	messageCreated: 'Chat.Events.Media.Text.Created',
	messageUpdated: 'Chat.Events.Media.Text.Updated',
	messagePinned: 'Chat.Events.Media.Text.Pinned',
	messageUnPinned: 'Chat.Events.Media.Text.UnPinned',
	messageBlocked: 'Chat.Events.Media.Block.Messages',
	messageUnlocked: 'Chat.Events.Media.Unblock.Messages',
	userBlocked: 'Chat.Events.Media.Block.Users',
	userUnblocked: 'Chat.Events.Media.Unblock.Users',
	reactionCreated: 'Chat.Events.Media.Reaction.Created',
	reactionUpdated: 'Chat.Events.Media.Reaction.Updated',
	pollCreated: 'Chat.Events.Media.Poll.Created',
	pollUpdated: 'Chat.Events.Media.Poll.Updated',
	pollPublished: 'Chat.Events.Media.Poll.Published',
	pollUnpublished: 'Chat.Events.Media.Poll.UnPublished',
	pollClosed: 'Chat.Events.Media.Poll.Closed',
	qnaCreated: 'Chat.Events.Media.QnA.Created',
	qnaUpdated: 'Chat.Events.Media.QnA.Updated',
	qnaPublished: 'Chat.Events.Media.QnA.Published',
	qnaUnpublished: 'Chat.Events.Media.QnA.UnPublished',
	qnaQuestionCreated: 'Chat.Events.Media.QnA.QuestionCreated',
	qnaQuestionApproveChanged: 'Chat.Events.Media.QnA.QuestionApproveChanged',
	qnaQuestionDiscardChanged: 'Chat.Events.Media.QnA.QuestionDiscardChanged',
	qnaQuestionUpvoted: 'Chat.Events.Media.QnA.QuestionUpvoted',
	qnaQuestionAnswered: 'Chat.Events.Media.QnA.QuestionAnswered',
	customPropUpdated: 'Library.Events.Media.CustomPropertySet',
};

export { NOTIFICATION_MESSAGES, getAccountId, getMediaId };
